
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kids-party-entertainment",
      function () {
        return require("private-next-pages/kids-party-entertainment/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kids-party-entertainment"])
      });
    }
  